import React from 'react';
import "../../main/main.css";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import paybackLogoImg from "./img/paybackLogo.png";
import paybackCardImg from "./img/paybackCard.png";
import { useActionListener } from 'redux-action-listener-hook';
import {isCardCode, isCouponCode} from "./util";
import {addErrorAlert, addPaybackCoupon, setPaybackCustomer} from "../../redux/actions";
import {useSelector} from "react-redux";

const ScanCustomerCard = (props) => {
    let cashierMode = useSelector(state => state.rootReducer.cashierMode);
    let payback = useSelector(state => state.rootReducer.payback);
    useActionListener('SCANNER_DETECTED', (dispatch, action) => {
        console.log({useActionListener: action});
        const scannedCode = action.payload;
        if(isCardCode(scannedCode)){
            dispatch(setPaybackCustomer(scannedCode));
        }else if(isCouponCode(scannedCode)){
            if(payback.coupons.indexOf(scannedCode) !== -1){
                dispatch(addErrorAlert('Coupon is already in the transaction!'));
            }else{
                dispatch(addPaybackCoupon(scannedCode));
            }
        }else{
            dispatch(addErrorAlert('Not a proper Payback card or coupon number!'));
        }
    });

    let paymentButton = (
        <div style={{marginBottom: "14px"}} onClick={e => {
            props.paybackInputDone();
        }}>
            <Button
                buttonStyle={{minWidth: "300px"}}
                type="button"
                className={"largeButton yellowButton"}
                name={<Translate id="Proceed"/>}
            />
        </div>
    );
    let enterCardCodeButton = (
        <div style={{marginBottom: "14px"}} onClick={e => {
            if(payback.customer === false) {
                props.enterCardCode();
            }else {
                props.enterCouponCode(payback.coupons);
            }
        }}>
            <Button buttonStyle={{minWidth: "300px"}} type="button" className={"largeButton blueBorderButton"} name={<Translate id="Add Payback manually"/>}/>
        </div>
    );

    let orLine = (
        <div style={{
            width: "300px",
            margin: "auto"
        }}>
            <div className={"diagonalLine"} style={{
                float: "left",
                marginTop: "40px"
            }}/>
            <span className={"coloredText"} style={{
                textTransform: "uppercase",
                fontStyle: "italic",
                fontSize: "20px"
            }}>
                <Translate id="or"/>
            </span>
            <div className={"diagonalLine"} style={{
                float: "right",
                marginTop: "10px"
            }}/>
        </div>
    );

    let contentInMode;
    if(cashierMode){
        contentInMode = <>
            <img src={paybackLogoImg} style={{
                width: 120,
                alignSelf: "center"
            }} alt="paybackLogoImg"/>
            <div style={{
                fontSize: "16px",
                width: "60%",
                margin: "30px auto 0px"
            }}>
                <Translate id={"Our customers can find the customer card and the eCoupons in the Payback app"}/>
            </div>
            <div style={{
                flexGrow: "1",
                alignContent: "center"
            }}>
                {orLine}
            </div>
            {enterCardCodeButton}
            {paymentButton}
        </>;
    }else{
        contentInMode = <>
            <img src={paybackCardImg} style={{
                maxWidth: "90%",
                maxHeight: "260px",
                display: "block",
                margin: "0px auto"
            }} alt="scanPaybackCard"/>
            <div style={{
                fontSize: "16px",
                width: "70%",
                margin: "50px auto 20px"
            }}>
                <Translate id={"You can find your customer card and the eCoupons in the Payback app"}/>
            </div>
            <div style={{
                flexGrow: 1
            }}/>
            {paymentButton}
        </>;
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: 54,
            bottom: 0,
            left: 0,
            right: 0
        }}>
            <span style={{
                whiteSpace: "pre-wrap",
                marginBottom: "5px"
            }} className={"boldUppercaseText"}>
                <Translate id={"Do you collect Payback points?"}/>
            </span>
            <span className={"boldUppercaseText"}>
                <Translate id={"Scan now!"}/>
            </span>
            <div style={{
                "marginBottom": "20px"
            }}/>
            { contentInMode }
        </div>
    );
}

export default ScanCustomerCard;